import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { toNumber } from "config/util";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

const useStyles = makeStyles({
  table: {
    // minWidth: 650,
  },
});

export default function DenseTable({
  set_price,
  active_price_global_buy,
  active_price_global_sell,
  active_pair,
}) {
  const maps = useSelector((state) => state.reduce_get_maps);
  const [t, i18n] = useTranslation();

  return (
    <TableContainer component={Paper}>
      <Table className="table-striped" size="small" aria-label="a dense table">
        {/* <TableHead>
          <TableRow>
            <TableCell align="left">時刻</TableCell>
            <TableCell align="right">
              <span style={{ color: "#4caf50" }}>{"買い"}</span>
              <span style={{ color: "#f44336" }}>{"売り"}</span>
              価格
            </TableCell>
            <TableCell align="right">数</TableCell>
          </TableRow>
        </TableHead> */}
        <TableBody>
          <TableRow
            onClick={() => {
              set_price(active_price_global_buy);
            }}
          >
            <TableCell
              align="left"
              style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
            >
              {t("買い指値最低制限")}
            </TableCell>
            <TableCell
              align="right"
              style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
            >
              <span style={{ color: "#4caf50" }}>
                {toNumber(
                  active_price_global_buy,
                  maps.coin_decimals[active_pair].price
                )}
              </span>
            </TableCell>
          </TableRow>
          <TableRow
            onClick={() => {
              set_price(active_price_global_sell);
            }}
          >
            <TableCell
              align="left"
              style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
            >
              {t("売り指値最高制限")}
            </TableCell>
            <TableCell
              align="right"
              style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
            >
              <span style={{ color: "#f44336" }}>
                {toNumber(
                  active_price_global_sell,
                  maps.coin_decimals[active_pair].price
                )}
              </span>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );

  // : "#f44336"
}
